import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

import "firebase/auth";
import "firebase/firestore";

var firebaseConfig = {
    apiKey: "AIzaSyC5OIxnAbrYyRhy43sabNK7tZ6GXo_uwWE",
    authDomain: "feiertage-c90a7.firebaseapp.com",  
    projectId: "feiertage-c90a7",  
    storageBucket: "feiertage-c90a7.appspot.com",  
    messagingSenderId: "625060338981",
    appId: "1:625060338981:web:02c148c2ba3bf952aececc"  
};

const firebaseApp = initializeApp(firebaseConfig);
export const db = getFirestore();

